import './RainfallTable.css';

type ChipProps = {
  icon?: string;
  children: React.ReactNode;
  tone?: 'temp' | 'rain' | 'humid' | 'neutral';
  className?: string;
  title?: string;
};

export function Chip({
  icon,
  children,
  tone = 'neutral',
  className = '',
  title,
}: ChipProps) {
  return (
    <span
      className={`chip chip--${tone} ${className}`}
      data-tooltip={title || ''}
    >
      {icon && <i className={`bi ${icon} chip__icon`} aria-hidden="true" />}
      <span className="chip__text">{children}</span>
    </span>
  );
}
